import { getSizingValue, useResponsiveValue } from "../../styling";
import { Box } from "../../box";
import { forwardRef } from "react";
import { isArray, isNil, mergeProps } from "../../shared";
import { useFormContext } from "../../form"; // See https://developer.mozilla.org/en-US/docs/Web/CSS/repeat.

import { jsx as _jsx } from "react/jsx-runtime";
export function repeat(count, repetition) {
  return `repeat(${count}, ${isArray(repetition) ? interpolateGridTemplateArray(repetition) : getSizingValue(repetition)})`;
} // See https://developer.mozilla.org/en-US/docs/Web/CSS/minmax.

export function minmax(min, max) {
  return `minmax(${getSizingValue(min)}, ${getSizingValue(max)})`;
} // See https://developer.mozilla.org/en-US/docs/Web/CSS/fit-content.

export function fitContent(dimension) {
  return `fit-content(${getSizingValue(dimension)})`;
}
const DefaultElement = "div";

function interpolateGridTemplateArray(values) {
  return values.map(x => getSizingValue(x)).join(" ");
}

export function InnerGrid({
  areas,
  as = DefaultElement,
  autoColumns,
  autoFlow,
  autoRows,
  children,
  forwardedRef,
  inline,
  templateColumns,
  templateRows,
  ...rest
}) {
  const areasValue = useResponsiveValue(areas);
  const templateColumnsValue = useResponsiveValue(templateColumns);
  const templateRowsValue = useResponsiveValue(templateRows);
  const [, isInFormContext] = useFormContext();
  const gridTemplateColumns = !isNil(templateColumnsValue) ? isArray(templateColumnsValue) ? interpolateGridTemplateArray(templateColumnsValue) : templateColumnsValue : undefined;
  const gridTemplateRows = !isNil(templateRowsValue) ? isArray(templateRowsValue) ? interpolateGridTemplateArray(templateRowsValue) : templateRowsValue : undefined; // Specialized defaults when a Grid is used in a form.

  const formProps = isInFormContext ? {
    gap: 4
  } : {};
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      display: inline ? "inline-grid" : "grid",
      gridAutoColumns: autoColumns,
      gridAutoFlow: autoFlow,
      gridAutoRows: autoRows,
      gridTemplateAreas: isArray(areasValue) ? areasValue.map(x => `"${x}"`).join(" ") : areasValue,
      gridTemplateColumns: gridTemplateColumns,
      gridTemplateRows: gridTemplateRows,
      ref: forwardedRef
    }, formProps),
    children: children
  });
}
InnerGrid.defaultElement = DefaultElement;
export const Grid = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerGrid, { ...props,
  forwardedRef: ref
}));